import {finalize} from "rxjs/operators";
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UserService} from "../../../../../@shared/services/user.service";
import {IPayback} from "../../../../../@core/enums/payback/interfaces/payback.interface";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ICreateOrUpdatePayback} from "../../../../../@core/enums/payback/interfaces/create-or-update-payback.interface";
import {WalletTypeEnum} from "../../../../../@core/enums/wallet-type.enum";
import {PaybackTypeEnum} from "../../../../../@core/enums/payback/enums/payback-type.enum";
import {PaybackLockTypeEnum} from "../../../../../@core/enums/payback/enums/payback-lock-type.enum";
import {PaybackActionTypeEnum} from "../../../../../@core/enums/payback/enums/payback-action-type.enum";

@Component({
  selector: 'app-payback-dialog',
  templateUrl: './payback-dialog.component.html',
  styleUrls: ['./payback-dialog.component.scss']
})
export class PaybackDialogComponent implements OnInit {

  public payback: IPayback | undefined = undefined;
  public isSubmitting = false;

  public paybackForm: FormGroup = this.fb.group({
    type: [null, [Validators.required]],
    actionType: [null, [Validators.required]],
    lockType: [null],
    payback: [null, [Validators.required]],
  })

  constructor(private userService: UserService,
              private fb: FormBuilder,
              public dialogRef: MatDialogRef<PaybackDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: IPayback) {
  }

  ngOnInit(): void {
    this.payback = this.data;

    if (this.payback) {
      this.paybackForm.patchValue({...this.payback, payback: 0});
    }
  }

  onSubmit(): void {
    if (this.paybackForm.invalid || this.isSubmitting) return;

    // В таблице и форме одна единица суммы; API принимает сотые с точностью до 0.001.
    const payback = Number((Number(this.paybackForm.value.payback) * 100).toFixed(3));
    if (!Number.isFinite(payback)) return;

    const body: ICreateOrUpdatePayback = {
      ...this.paybackForm.value,
      payback,
      userId: this.userService.currentUserId.getValue(),
    }

    this.isSubmitting = true;
    this.userService.createOrUpdatePayback(body)
      .pipe(finalize(() => this.isSubmitting = false))
      .subscribe((response: IPayback) => {
        if (response) {
          this.dialogRef.close(true);
        }
      });
  }

  public close(): void {
    this.dialogRef.close(false);
  }

  protected readonly WalletTypeEnum = WalletTypeEnum;
  protected readonly Object = Object;
  protected readonly PaybackTypeEnum = PaybackTypeEnum;
  protected readonly PaybackLockTypeEnum = PaybackLockTypeEnum;
  protected readonly PaybackActionTypeEnum = PaybackActionTypeEnum;
}
